var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 6.66697C2.40034 6.47302 2.44261 6.28139 2.52425 6.10545C2.60589 5.92951 2.72492 5.7735 2.87306 5.6483L7.53972 1.64897C7.78038 1.44558 8.0853 1.33398 8.40039 1.33398C8.71549 1.33398 9.0204 1.44558 9.26106 1.64897L13.9277 5.6483C14.0759 5.7735 14.1949 5.92951 14.2765 6.10545C14.3582 6.28139 14.4004 6.47302 14.4004 6.66697V12.667C14.4004 13.0206 14.2599 13.3597 14.0099 13.6098C13.7598 13.8598 13.4207 14.0003 13.0671 14.0003H3.73372C3.3801 14.0003 3.04096 13.8598 2.79091 13.6098C2.54087 13.3597 2.40039 13.0206 2.40039 12.667V6.66697Z",
    stroke: "#616E85",
    strokeWidth: 1.13426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7566 6.84065C10.5445 6.62965 10.2747 6.48629 9.98113 6.42869C9.6876 6.37109 9.38357 6.40185 9.10752 6.51706C8.92084 6.59174 8.75283 6.70375 8.6097 6.84687L8.39813 7.05844L8.18033 6.84687C7.96899 6.63483 7.69946 6.4903 7.40589 6.43158C7.11233 6.37287 6.80794 6.40262 6.5313 6.51706C6.34462 6.59174 6.18283 6.70375 6.0397 6.84687C5.44854 7.43181 5.41743 8.42123 6.16416 9.17418L8.39813 11.3833L10.6383 9.17418C11.3851 8.42123 11.3477 7.43181 10.7566 6.84687V6.84065Z",
    stroke: "#616E85",
    strokeWidth: 1.13426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.ba007f2da1b3a7ecabb9ccb8d3ca6f3b.svg";
export { ForwardRef as ReactComponent };